"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const prop_types_1 = __importDefault(require("prop-types"));
const keyValuePane = ({ width, columns }) => (React.createElement(polaris_1.ColumnLayout, { columns: width, variant: "text-grid" },
    React.createElement("div", { "data-awsui-column-layout-root": "true" }, columns.map((column, columnIndex) => (React.createElement("div", { key: columnIndex },
        React.createElement("div", { className: "awsui-util-spacing-v-s" }, column.map((item, itemIndex) => {
            return (item.value && (React.createElement("div", { key: itemIndex },
                React.createElement("div", { className: "awsui-util-label" }, item.key),
                React.createElement("div", null, item.value))));
        }))))))));
keyValuePane.displayName = 'KeyValuePane';
keyValuePane.propTypes = {
    width: prop_types_1.default.number,
    columns: prop_types_1.default.array,
};
exports.default = keyValuePane;
//# sourceMappingURL=KeyValuePane.js.map